(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["badges-banner"] && !Shopify.designMode) return;
  try {
    
  function initBadgesBanner(section) {
    var ctas = section.querySelectorAll('.badges-banner__cta[data-scroll-to]');

    ctas.forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var selector = this.getAttribute('data-scroll-to');
        if (!selector) return;
        var target = document.querySelector(selector);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  }

  function initAllBadgesBanners() {
    document.querySelectorAll('.badges-banner').forEach(function (el) {
      if (el.dataset.initialized) return;
      el.dataset.initialized = 'true';
      initBadgesBanner(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBadgesBanners);
  } else {
    initAllBadgesBanners();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.badges-banner');
    if (section) {
      section.dataset.initialized = '';
      initBadgesBanner(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.badges-banner');
    if (section) {
      section.dataset.initialized = '';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const anchorScrollBtn = document.querySelector('.js-benefits-anchor-scroll');

    if (anchorScrollBtn) {
      anchorScrollBtn.addEventListener('click', function (e) {
        e.preventDefault();

        const targetSelector = this.getAttribute('data-scroll-target');
        if (!targetSelector) return;

        const targetElement = document.querySelector(targetSelector);

        if (targetElement) {
          const elementRect = targetElement.getBoundingClientRect();
          const bodyRect = document.body.getBoundingClientRect();
          const offset = elementRect.top - bodyRect.top - 100;

          document.body.scrollTo({
            top: offset,
            behavior: 'smooth',
          });
          window.scrollTo({
            top: offset,
            behavior: 'smooth',
          });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buy-box-lp"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-scroll-selector]');
    if (!link) return;
    var target = document.querySelector(link.dataset.scrollSelector);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var section = document.querySelector('.buyBoxLpSection[data-sale-price]');
  if (section) {
    window.buyBoxStickyPrice = section.dataset.salePrice;
    window.buyBoxCurrencySymbol = section.dataset.currencySymbol;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["confidence-corner"] && !Shopify.designMode) return;
  try {
    
  function initConfidenceCornerScroll() {
    window.scrollToBlocks = function (element) {
      const scrolldiv = document.querySelector(element);
      if (scrolldiv) {
        const elementRect = scrolldiv.getBoundingClientRect();
        const bodyRect = document.body.getBoundingClientRect();
        const offset = elementRect.top - bodyRect.top - 50;

        document.body.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
      } else {
        window.location.href = `/${element}`;
      }
    };
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConfidenceCornerScroll);
  } else {
    initConfidenceCornerScroll();
  }

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', function (event) {
    const sectionElement = document.querySelector(
      '.confidenceCorner[data-section-id="' + event.detail.sectionId + '"]'
    );
    if (sectionElement) {
      initConfidenceCornerScroll();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-banner"] && !Shopify.designMode) return;
  try {
    
  function initCtaBannerScroll(section) {
    section.addEventListener('click', function (e) {
      var link = e.target.closest('[data-scroll-to]');
      if (!link || !section.contains(link)) return;
      var selector = link.getAttribute('data-scroll-to');
      if (!selector) return;
      var target = document.querySelector(selector);
      if (!target) return;
      e.preventDefault();
      var offset = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    });
  }

  function initAllCtaBanner() {
    document.querySelectorAll('.cta-banner').forEach(function (section) {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      initCtaBannerScroll(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCtaBanner);
  } else {
    initAllCtaBanner();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.cta-banner');
    if (section) {
      section.dataset.initialized = '';
      initAllCtaBanner();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-testimonial"] && !Shopify.designMode) return;
  try {
    
  function initCtaTestimonialScroll(section) {
    section.addEventListener('click', function (e) {
      var link = e.target.closest('[data-scroll-to]');
      if (!link || !section.contains(link)) return;
      var selector = link.getAttribute('data-scroll-to');
      if (!selector) return;
      var target = document.querySelector(selector);
      if (!target) return;
      e.preventDefault();
      var offset = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    });
  }

  function initAllCtaTestimonial() {
    document.querySelectorAll('.cta-testimonial').forEach(function (section) {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      initCtaTestimonialScroll(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCtaTestimonial);
  } else {
    initAllCtaTestimonial();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.cta-testimonial');
    if (section) {
      section.dataset.initialized = '';
      initAllCtaTestimonial();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-social-proof"] && !Shopify.designMode) return;
  try {
    
  function initScrollLinks(section) {
    section.addEventListener('click', function (e) {
      var link = e.target.closest('[data-scroll-to]');
      if (!link || !section.contains(link)) return;
      var selector = link.getAttribute('data-scroll-to');
      if (!selector) return;
      var target = document.querySelector(selector);
      if (!target) return;
      // Prevent the anchor CTA from navigating when it scrolls instead.
      e.preventDefault();
      var offset = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    });
  }

  function initAllHeroSocialProof() {
    document.querySelectorAll('.hero-social-proof').forEach(function (section) {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      initScrollLinks(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeroSocialProof);
  } else {
    initAllHeroSocialProof();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.hero-social-proof');
    if (section) {
      section.dataset.initialized = '';
      initAllHeroSocialProof();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["his-hers-bundle"] && !Shopify.designMode) return;
  try {
    
  function initHisHersBundleScroll() {
    const scrollButtons = document.querySelectorAll('.js-scroll-to');

    scrollButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        const targetSelector = this.getAttribute('data-scroll-target');
        const targetElement = document.querySelector(targetSelector);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      });
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', initHisHersBundleScroll);

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', function (event) {
    const sectionElement = document.querySelector('.hisHersBundle[data-section-id="' + event.detail.sectionId + '"]');
    if (sectionElement) {
      initHisHersBundleScroll();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-banner"] && !Shopify.designMode) return;
  try {
    
  function initInfoBannerScroll() {
    const scrollButtons = document.querySelectorAll('.js-scroll-to');

    scrollButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        const targetSelector = this.getAttribute('data-scroll-target');
        const targetElement = document.querySelector(targetSelector);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      });
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', initInfoBannerScroll);

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', function (event) {
    const sectionElement = document.querySelector('.infoBanner[data-section-id="' + event.detail.sectionId + '"]');
    if (sectionElement) {
      initInfoBannerScroll();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle"] && !Shopify.designMode) return;
  try {
    
  function initListicleScroll(section) {
    section.addEventListener('click', function (e) {
      var link = e.target.closest('[data-scroll-to]');
      if (!link || !section.contains(link)) return;
      var selector = link.getAttribute('data-scroll-to');
      if (!selector) return;
      var target = document.querySelector(selector);
      if (!target) return;
      e.preventDefault();
      var offset = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    });
  }

  function initAllListicle() {
    document.querySelectorAll('.listicle').forEach(function (section) {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      initListicleScroll(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllListicle);
  } else {
    initAllListicle();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.listicle');
    if (section) {
      section.dataset.initialized = '';
      initAllListicle();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicles-offer"] && !Shopify.designMode) return;
  try {
    
  function initCountdownTimer() {
    const counterElement = document.querySelector('.js-offer-counter');
    const hoursElement = document.querySelector('.js-offer-hrs');
    const minutesElement = document.querySelector('.js-offer-mins');
    const secondsElement = document.querySelector('.js-offer-sec');

    if (!counterElement || !hoursElement || !minutesElement || !secondsElement) {
      return;
    }

    const updateCountdown = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const timeRemaining = midnight.getTime() - now.getTime();

      if (timeRemaining > 0) {
        const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        hoursElement.textContent = hours.toString().padStart(2, '0');
        minutesElement.textContent = minutes.toString().padStart(2, '0');
        secondsElement.textContent = seconds.toString().padStart(2, '0');
      } else {
        hoursElement.textContent = '24';
        minutesElement.textContent = '00';
        secondsElement.textContent = '00';
      }
    };

    updateCountdown();

    setInterval(updateCountdown, 1000);
  }

  document.addEventListener('DOMContentLoaded', initCountdownTimer);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.js-offer-counter')) {
      initCountdownTimer();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-nav"] && !Shopify.designMode) return;
  try {
    
  window.scrollToBlock = function (element) {
    var scrolldiv = document.querySelector(element);
    if (scrolldiv) {
      var elementRect = scrolldiv.getBoundingClientRect();
      var bodyRect = document.body.getBoundingClientRect();
      var offset = elementRect.top - bodyRect.top - 50;

      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      });
    }
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar-with-timer"] && !Shopify.designMode) return;
  try {
    
  function initPromoTimer(section) {
    var hrs = section.querySelectorAll('.js-phr-timer-hrs');
    var min = section.querySelectorAll('.js-phr-timer-min');
    var sec = section.querySelectorAll('.js-phr-timer-sec');
    if (!hrs.length) return;

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(23, 59, 59, 999);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      hrs.forEach(function (el) { el.textContent = pad(h); });
      min.forEach(function (el) { el.textContent = pad(m); });
      sec.forEach(function (el) { el.textContent = pad(s); });
    }

    tick();
    section._timerInterval = setInterval(tick, 1000);
  }

  function initAllPromoBars() {
    document.querySelectorAll('.promo-bar-with-timer').forEach(function (section) {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      initPromoTimer(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPromoBars);
  } else {
    initAllPromoBars();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.promo-bar-with-timer');
    if (section) {
      section.dataset.initialized = '';
      initAllPromoBars();
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.promo-bar-with-timer');
    if (section && section._timerInterval) {
      clearInterval(section._timerInterval);
      section._timerInterval = null;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
